// Calculate if nextpage exist for infiniteQuery, if exist return next page number otherwise return undefined

import type { InfiniteData } from '@tanstack/react-query';
import type { TableResult } from 'common/models';
import type { MaterialAtStore, StoreDetail } from 'pages/material/models';

import { defaultEventLogQuery } from './auditHelper';

// based on result hasNextPage props is set, if pageParam is number hasNextPage is true otherwise else
export const getInfiniteNextPageParam = <T>(lastPage: T[], pages: T[][], pageSize?: number) => {
  const size = pages.reduce((acc, page) => [...acc, ...page], []).length;

  if (size === pages.length * (pageSize || defaultEventLogQuery.pageSize)) {
    return pages.length + 1;
  }

  return undefined;
};

export const getInfiniteNextPageParamV2 = <T>(
  lastPage: TableResult<T>,
  pages: TableResult<T>[]
) => {
  const loadedCount = pages.reduce((acc, page) => acc + page.data.length, 0);

  if (loadedCount < lastPage.total) {
    return pages.length + 1;
  }

  return undefined;
};

export const getTableResultData = <T>(data?: InfiniteData<TableResult<T>>): T[] => {
  return data?.pages.reduce((acc: T[], page) => [...acc, ...page.data], []) || [];
};

export const getStoreDetailMaterialData = (data?: InfiniteData<StoreDetail>): MaterialAtStore[] => {
  return (
    data?.pages.reduce((acc: MaterialAtStore[], page) => [...acc, ...page.material.data], []) || []
  );
};
